import { Component, OnInit } from '@angular/core';

import {LanguageService} from '../language/language.service';

@Component({
  selector: 'app-page-does-not-exist',
  templateUrl: './page-does-not-exist.component.html',
  styleUrls: ['./page-does-not-exist.component.scss']
})
export class PageDoesNotExistComponent implements OnInit {

  constructor(public languageService: LanguageService) { }

  ngOnInit(): void {
  }

}
